'use client';
import TestimonialCard from '../cards/testimonial-card';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import Container from '../container';
import { TestimonialsBreakPoints } from '@/constants/swiperBreakPoints.constants';

const TestimonialsSlider = ({ data = {}, isMobile, locale }) => {
  return (
    <Container className='flex flex-col items-start gap-3.5 py-0 md:my-8 md:gap-6 lg:flex-row lg:gap-[72px]'>
      <div className='mt-3.5 w-full lg:w-1/3'>
        <p className='mb-2 text-sm font-semibold uppercase sm:text-base md:mb-2 md:text-xl lg:mb-4 lg:text-2xl'>
          {data?.[`title-${locale}`]}
        </p>
        <p className='max-sm:text-[11px] sm:text-sm'>
          {data?.[`description-${locale}`]}
        </p>
      </div>

      <div className='w-full min-w-0'>
        <Swiper
          key={locale}
          modules={[Pagination, Autoplay]}
          autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
          dir={locale === 'en' ? 'ltr' : 'rtl'}
          pagination={{ clickable: true }}
          className='testimonials_pagination'
          breakpoints={TestimonialsBreakPoints}
        >
          {data?.value?.map((info, i) =>
            (isMobile ? info?.['mobile-active'] : info?.active) ? (
              <SwiperSlide key={i} className='md:max-w-72 md:min-w-72'>
                <TestimonialCard
                  {...{
                    locale,
                    info,
                  }}
                />
              </SwiperSlide>
            ) : null
          )}
        </Swiper>
      </div>
    </Container>
  );
};

export default TestimonialsSlider;
